import React from "react";
import ReactDOM from "react-dom";
import PublicMenu from "./components/PublicMenu";
import {Domain} from "@zooplus/commons-lang";

const component = document.getElementById('bonus-points-public-menu-wrapper');

if (component) {
    const siteDomain = component.getAttribute('data-site-domain') as Domain;
    const selectedMenuItem = component.getAttribute('data-selected-menu-item');
    const bpEnabled = JSON.parse(component.getAttribute('data-enabled')!);

    if (
        siteDomain &&
        selectedMenuItem
    ) {
        ReactDOM.render(
            <PublicMenu
                siteDomain={siteDomain}
                selectedMenuItem={selectedMenuItem}
                bpEnabled={bpEnabled}
            />,
            component
        );
    }
}
